import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { Tabs } from "components";
import "modules/DealerDetails/components/DealerDetailsHeader/DealerDetailsHeader.scss";
import { PATHS } from "router/paths";

import type { TabData } from "components";

type DealerDetailsHeaderProps = {
  isUpdateDealerPending: boolean;
};

export const DealerDetailsHeader = ({ isUpdateDealerPending }: DealerDetailsHeaderProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const tabs: Map<string, TabData> = new Map([
    ["general", { data: [], id: "general", title: t("v8_general", "General"), icon: <Icon className="gears" /> }],
    ["gdprAvg", { data: [], id: "gdprAvg", title: t("v8_gdpr_avg", "GDPR - AVG"), icon: <Icon className="shield halved" /> }],
    ["invoicing", { data: [], id: "invoicing", title: t("v8_invoice_settings", "Invoice Settings"), icon: <Icon className="file invoice dollar" /> }],
    ["dmsSystem", { data: [], id: "dmsSystem", title: t("v8_dms_system", "DMS / System"), icon: <Icon className="cloud" /> }],
    ["configuration", { data: [], id: "configuration", title: t("v8_configuration", "Configuration"), icon: <Icon className="sliders" /> }],
    ["ponOil", { data: [], id: "ponOil", title: t("v8_pon_oil_configuration", "PON Oil configuration"), icon: <Icon className="oil can" /> }],
    ["service", { data: [], id: "service", title: t("v8_service", "Service"), icon: <Icon className="wrench" /> }]
  ]);

  return (
    <div className="DealerDetailsHeader">
      <div className="row center">
        <div className="full tabs">
          <Tabs data={tabs} />
        </div>
        <div className="actions">
          <Button type="button" basic onClick={() => history.push(PATHS.DEALERS_DASHBOARD)}>
            {t("v8_cancel", "Cancel")}
          </Button>
          <Button color="green" type="submit" disabled={isUpdateDealerPending} loading={isUpdateDealerPending}>
            {t("v8_save", "Save")}
            <Icon className="check" />
          </Button>
        </div>
      </div>
    </div>
  );
};
